import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import './scss/styles.scss';

import client from './client.js';
import { ApolloProvider } from '@apollo/react-hooks';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import Layout from './components/Layout';

class ErrorBoundary extends React.Component {
    state = {
        error: null
    };

    componentDidCatch(error, errorInfo) {
        console.log(error);
        this.setState({ error });
    }

    render() {
        if (this.state.error) {
            return <Layout>
                <div className="main-wrapper">
                    <section>
                        <h2 className="mb-12">AudioEngine Gateway</h2>
                        <h4>An Error Ocurred</h4>
                        <p> Please try again. </p>
                    </section>
                </div>
            </Layout>
        }

        return this.props.children;
    }
}

const AppWrapper = () => (
    <ErrorBoundary>
        <Router>
            <AuthProvider>
                <ApolloProvider client={client}>
                    <App />
                    <ToastContainer />
                </ApolloProvider>
            </AuthProvider>
        </Router>
    </ErrorBoundary>
);

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
